import Env from './env';
import Cookies from 'js-cookie';
let config = {};
// 环境
config.env = Env;
// 开发环境Url
config.baseUrl = '';
// 项目名称
config.projectName = '绿色出行共享平台';

config.page = {
    // 每页显示数据条数配置
    opts: [5, 10, 20, 50],
    opts500: [5, 10, 20, 50, 100, 200, 500, 1000],
    // 每页显示数据条数
    pageSize: 10,
    // 分页组件的布局
    layout: 'total, prev, pager, next, sizes,jumper',
    // 最大页显示数
    maxPageSize: 99999
};
//充电桩管理
config.pileManage = {
    List: {
        name: '充电桩管理',
        name_en: 'charge_list'
    },
    Detail: {
        editName: '充电桩编辑',
        addName: '充电桩新增',
        name_en: 'charge_detail'
    },
    ShowMessage: {
        name: "查看OTARecord详情",
        name_en: 'otarecord_showMsg'
    },
    listPath: 'pile_manage/charge_list'
};
//充电站管理
config.pileStation = {
        List: {
            name: '充电站管理',
            name_en: 'pilestation_list'
        },
        Detail: {
            editName: '充电站编辑',
            addName: '充电站新增',
            name_en: 'pileStation_detail'
        },
        showPileInfo: {
            name: "充电桩信息",
            name_en: "pileInfo_list"
        },
        listPath: 'pile_manage/pileStation_list'
    },
    //RCS型号管理
    config.rcstype = {
        List: {
            name: 'RCS型号管理',
            name_en: "rcstype_list"
        },
        Detail: {
            editName: 'RCS型号编辑',
            addName: 'RCS型号添加',
            name_en: 'rcstype_detail'
        },
        listPath: 'pile_manage/rcstype_list'
    };
//RCS设备管理
config.rcs = {
    List: {
        name: 'RCS设备管理',
        name_en: 'rcs_list'
    },
    Detail: {
        editName: 'RCS设备编辑',
        addName: 'RCS设备添加',
        name_en: 'rcs_detail',
    },
    listPath: 'pile_manage/rcs_list'
};
// 角色
config.role = {
    List: {
        name: '角色管理',
        name_en: 'role_list'
    },
    Detail: {
        editName: '角色编辑',
        addName: '角色新增',
        name_en: 'role_detail'
    },
    listPath: 'sys_manage/role_list'
};
//二维码
config.event = {
        List: {
            name: "二维码管理",
            name_en: "event_list"
        },
        Detail: {
            editName: "二维码编辑",
            addName: "二维码新增",
            name_en: "event_detail"
        },
        listPath: 'server_manage/event_list'
    },
    // 用户
    config.user = {
        List: {
            name: '用户管理',
            name_en: 'user_list'
        },
        Detail: {
            editName: '用户编辑',
            addName: '用户新增',
            name_en: 'user_detail'
        },
        ResetPwd: {
            name: '重置密码',
            name_en: 'user_resetPwd'
        },
        listPath: 'sys_manage/user_list'
    };
// 日志
config.ota = {
    command: {
        name: '命令日志',
        name_en: 'otacommand_list',

    },
    record: {
        name: '实时上报',
        name_en: 'otarecord_list',
    },
    loginlog: {
        name: '登录日志',
        name_en: 'loginlog_list',
    },
    actionlog: {
        name: '操作日志',
        name_en: 'actionlog_list',
    }
};
// 设备管理
config.terminal = {
    List: {
        name: '设备列表',
        name_en: 'terminal_list'
    },
    Detail: {
        editName: '设备编辑',
        addName: '设备新增',
        name_en: 'terminal_detail'
    },
    listPath: 'terminal_manage/terminal_list'
};
// 站点管理
config.rental = {
    List: {
        name: '网点列表',
        name_en: 'rental_list'
    },
    Detail: {
        editName: '网点编辑',
        addName: '网点新增',
        name_en: 'rental_detail'
    },
    Delete: {
        name: '网点车辆',
        name_en: 'rental_delete'
    },
    Add: {
        name: '分配车辆',
        name_en: 'rental_add'
    },
    listPath: 'rental_manage/rental_list'
};
// 围栏管理
config.fence = {
    List: {
        name: '围栏列表',
        name_en: 'fence_list'
    },
    Detail: {
        editName: '围栏编辑',
        addName: '围栏新增',
        name_en: 'fence_detail'
    },
    Fence: {
        name: '查看围栏',
        name_en: 'fence_show'
    },
    Add: {
        name: '绑定车辆',
        name_en: 'fence_add'
    },
    Remove: {
        name: '解绑车辆',
        name_en: 'fence_remove'
    },
    AddPhone: {
        name: '短信推送设置',
        name_en: 'fencephone_add'
    },
    listPath: 'car_manage/fence_list'
};
// 客户反馈
config.custfeedback = {
    List: {
        name: '客户反馈',
        name_en: 'feedback_list'
    },
    Detail: {
        editName: '回复内容编辑',
        name_en: 'feedback_detail'
    },
};
//车队管理
config.autoTeam = {
    List: {
        name: '车队管理',
        name_en: "autoteam_list"
    },
    Detail: {
        addName: '车队新增',
        editName: "车队编辑",
        name_en: "autoteam_detail"
    },
    listPath: 'car_manage/autoteam_list'
};
//车辆停留汇总
config.autoStopSummary = {
    List: {
        name: '车辆停留汇总',
        name_en: "autostopsummary_list"
    },
    listPath: 'car_manage/autostopsummary_list'
};
//车辆停留记录
config.autoStopRecord = {
    List: {
        name: '车辆停留记录',
        name_en: "autostoprecord_list"
    },
    StopPlace: {
        name: '车辆停留位置',
        name_en: "stop_place"
    },
    listPath: 'car_manage/autostoprecord_list'
};
//车辆维修
config.autoMatain = {
    List: {
        name: "车辆运维",
        name_en: "autoMatain_list"
    },
    Detail: {
        addName: "车辆运维新增",
        editName: "车辆运维编辑",
        name_en: "autoMatain_detail"
    },
    listPath: "car_manage/autoMatain_list"
}
// 客户推送消息
config.custpushmsg = {
    List: {
        name: '客户推送消息',
        name_en: 'custpushmsg_list'
    },
    Detail: {
        editName: '消息编辑',
        name_en: 'custpushmsg_detail'
    },
};

// 景点管理
config.travelPlace = {
    List: {
        name: '景点列表',
        name_en: 'travelPlace_list'
    },
    Detail: {
        editName: '景点编辑',
        addName: '景点新增',
        name_en: 'travelPlace_detail'
    },
    // listPath: 'rental_manage/rental_list'
};
// app版本控制
config.app = {
    List: {
        name: '版本管理',
        name_en: 'appversion_list'
    },
    Detail: {
        addName: '新建版本',
        editName: '编辑版本',
        name_en: 'appversion_detail'
    },
    listPath: 'sys_manage/appversion_list'
};

// 公司管理
config.corp = {
    List: {
        name: '公司管理',
        name_en: 'corp_list'
    },
    Detail: {
        addName: '公司新增',
        editName: '公司编辑',
        name_en: 'corp_detail'
    },
    listPath: 'sys_manage/corp_list'
};
//组织机构
config.org = {
    List: {
        name: '组织机构',
        name_en: 'org_list'
    },
    Detail: {
        addName: '机构新增',
        editName: '机构编辑',
        name_en: 'org_detail',
    },
    listPath: 'sys_manage/org_list'
};
// 客户管理
config.cust = {
    List: {
        name: '客户列表',
        name_en: 'cust_list'
    },
    Detail: {
        addName: '客户新增',
        editName: '客户编辑',
        name_en: 'cust_detail'
    },
    SendMessage: {
        name: '发送消息',
        name_en: 'cust_sendMessage'
    },
    ResetMoblie: {
        name: '重置手机号',
        name_en: 'cust_resetMoblie'
    },
    ResetPwd: {
        name: '重置密码',
        name_en: 'cust_resetPwd'
    },
    Check: {
        name: '客户信息审核',
        name_en: 'cust_check'
    },
    listPath: 'cust_manage/cust_list'
};
config.custFinance = {
    List: {
        name: '财务处理',
        name_en: 'custFinance_list'
    },
    listPath: 'finance_manage/custFinance_list'
};
//通讯记录
config.pileotarecord = {
    ShowMessage: {
        name: '查看详情',
        name_en: 'pileotarecord_showMsg'
    },
}
// 发票管理
config.custInvoice = {
    List: {
        name: '发票管理',
        name_en: 'custInvoice_list'
    },
    Detail: {
        addName: '填写发货单',
        editName: '编辑发货单',
        name_en: 'custInvoice_detail'
    },
    listPath: 'finance_manage/custInvoice_list'
};
// 订单管理
config.order = {
    List: {
        name: '订单管理',
        name_en: 'order_list'
    },
    Detail: {
        name: '订单详情',
        name_en: 'order_detail'
    },
    EditOrder: {
        name: '修改结算金额',
        name_en: 'order_editOrder'
    },
    OrderLvar: {
        name: '事故登记',
        name_en: 'order_orderlvar'
    },
    Feedback: {
        name: '订单反馈',
        name_en: 'order_feedback'
    },
    listPath: 'order_manage/order_list'
};

//运维订单管理
config.optorder = {
    List: {
        name: '运维订单',
        name_en: 'optorder_list'
    },
    listPath: 'operation_manage/optorder_list'
};

// 优惠券管理
config.coupon = {
    List: {
        name: '优惠券管理',
        name_en: 'coupon_list'
    },
    Detail: {
        addName: '优惠券新增',
        editName: '优惠券编辑',
        name_en: 'coupon_detail'
    },
    listPath: 'server_manage/coupon_list'
};
//客户优惠券管理
config.custcoupon = {
    Add: {
        name: '分配优惠券',
        name_en: 'custcoupon_list'
    },
    Remove: {
        name: '查看优惠券',
        name_en: 'custcoupon_detail'
    },
    listPath: 'cust_manage/coupon_list'
};
//资金管理
config.custwalletlist = {
    List: {
        name: '客户资金',
        name_en: 'custwalletlist_list'
    },
    listPath: 'cust_manage/custwalletlist_list'
};
//资金管理
config.walletlist = {
    List: {
        name: '资金列表',
        name_en: 'walletlist_list'
    },
    listPath: 'finance_manage/walletlist_list'
};
// 客户钱包管理
config.custwallet = {
    Change: {
        name: '资金处理',
        name_en: 'cust_change'
    },
    listPath: 'cust_manage/custwallet_list'
};
// 资费包管理
config.tariffgroup = {
    List: {
        name: '资费包列表',
        name_en: 'tariffgroup_list'
    },
    Detail: {
        addName: '资费包新增',
        editName: '资费包编辑',
        name_en: 'tariffgroup_detail'
    },
    listPath: 'tariff_manage/tariffgroup_list'
};
// 费用管理
config.feeitem = {
    List: {
        name: '费用管理',
        name_en: 'feeitem_list'
    },
    Detail: {
        addName: '费用新增',
        editName: '费用编辑',
        name_en: 'feeitem_detail'
    },
    listPath: 'tariff_manage/feeitem_list'
};

// 资费管理
config.tariff = {
    List: {
        name: '资费包管理',
        name_en: 'tariff_list'
    },
    Detail: {
        addName: '资费新增',
        editName: '资费编辑',
        name_en: 'tariff_detail'
    },
    listPath: 'server_manage/tariff_list' //
};

// 客户退费管理
config.custWalletEarnestWithDraw = {
    List: {
        name: '退费管理',
        name_en: 'custWalletEarnestWithDraw_list'
    },
    Agree: {
        agreeName: '财务处理',
        name_en: 'custWalletEarnestWithDraw_agree'
    },
    verify: {
        name: '退款审核',
        name_en: 'custWalletEarnestWithDraw_verify'
    },
    listPath: 'finance_manage/custWalletEarnestWithDraw_list'
};

// 车型管理
config.automodel = {
    List: {
        name: '车型管理',
        name_en: 'automodel_list'
    },
    Detail: {
        editName: '车型编辑',
        addName: '车型新增',
        name_en: 'automodel_detail'
    },
    listPath: 'car_manage/automodel_list'
};

// 车辆管理
config.auto = {
    List: {
        name: '车辆列表',
        name_en: 'auto_list'
    },
    Detail: {
        editName: '车辆编辑',
        addName: '车辆新增',
        name_en: 'auto_detail'
    },
    Deal: {
        name: '车辆处理',
        name_en: 'auto_deal'
    },
    MonthCheck: {
        name: '月检记录',
    },
    listPath: 'car_manage/auto_list'
};

//赛迪巴斯大巴屏幕展示
config.sdbs = {
    BigMap: {
        name: '赛迪巴斯大巴屏幕展示',
        name_en: 'sdbs_bus'
    },
    listPath: 'car_manage/sdbs_bus'
};

//车辆保险
config.autoinsurance = {
    List: {
        name: '车辆保险',
        name_en: 'autoinsurance_list'
    },
    Detail: {
        editName: '车辆保险编辑',
        addName: '车辆保险新增',
        name_en: 'autoinsurance_detail'
    },
    listPath: 'car_manage/autoinsurance_list'
};
//车辆电池管理
config.autobattery = {
    List: {
        name: '车辆电池',
        name_en: 'autobattery_list'
    },
    Detail: {
        editName: '车辆电池编辑',
        addName: '车辆电池新增',
        name_en: 'autobattery_detail'
    },
    Deal: {
        name: '电池信息',
        name_en: 'battery_detail'
    },
    listPath: 'car_manage/autobattery_list'
};
// 设备实时状态
config.tmnlreal = {
    List: {
        name: '设备状态',
        name_en: 'tmnlreal_list'
    },
    Autolist: {
        name: '车辆实时状态'
    },
    listPath: 'terminal_manage/tmnlreal_list'
};
// 设备测试
config.tmnltest = {
    TmnlTest: {
        name: '设备测试',
        name_en: 'tmnltest_tmnltest'
    },
    listPath: 'terminal_manage/tmnltest_tmnltest'
};
// 桩信息列表
config.pileinfo = {
    List: {
        name: '桩列表',
        name_en: 'pile_list'
    },
    pile_control: {
        name: '桩控制',
        name_en: 'pile_control'
    },
    listPath: 'pile_manage/pile_list'
};

// 系统通知
config.alert = {
    List: {
        name: '系统通知',
        name_en: 'alert_list'
    },
    Detail: {
        editName: '通知编辑',
        addName: '通知新增',
        name_en: 'alert_detail'
    },
    listPath: 'sys_manage/alert_list'
}

//运维人员管理
config.operation = {
    List: {
        name: '运维人员',
        name_en: 'operation_list'
    },
    Detail: {
        editName: '运维人员编辑',
        addName: '运维人员新增',
        name_en: 'operation_detail'
    },
    ResetPwd: {
        name: '重置密码',
        name_en: 'operation_resetPwd'
    },
    listPath: 'operation_manage/operation_list'
}

// 预约订单管理
config.book = {
    List: {
        name: '预约订单',
        name_en: 'book_list'
    },
    listPath: 'server_manage/book_list'
}

//消息群推管理
config.pushmessage = {
    List: {
        name: '消息群推',
        name_en: 'pushmessage_list'
    },
    ListPush: {
        name: '批量推送',
        name_en: 'pushmessage_listpush'
    },
    SinglePush: {
        name: '选择推送',
        name_en: 'pushmessage_singlepush'
    },
    listPath: 'sys_manage/pushmessage_list'
}

// 折扣管理
config.discount = {
    List: {
        name: '折扣管理',
        name_en: 'discount_list'
    },
    Detail: {
        addName: '折扣新增',
        editName: '折扣编辑',
        name_en: 'discount_detail'
    },
    listPath: 'server_manage/discount_list'
}


//兑换卡
config.cashcard = {
    List: {
        name: '兑换卡',
        name_en: 'cashcard_list'
    },
    Detail: {
        addName: '兑换卡新增',
        editName: '兑换卡编辑',
        name_en: 'cashcard_detail'
    },
    listPath: 'server_manage/cashcard_list'
}

//广告页面
config.advert = {
    List: {
        name: '广告页面',
        name_en: 'advert_list'
    },
    Detail: {
        addName: '广告页面新增',
        editName: '广告页面编辑',
        name_en: 'advert_detail'
    },
    listPath: 'server_manage/advert_list'
}
config.advertDelivery = {
    List: {
        name: '广告投放',
        name_en: 'advert_delivery_list'
    },
    Detail: {
        addName: '广告投放新增',
        editName: '广告投放编辑',
        name_en: 'advert_delivery_detail'
    },
    listPath: 'server_manage/advert_delivery_list'
}
//商品管理页面
config.goods = {
    List: {
        name: '商品管理',
        name_en: 'goods_list'
    },
    Detail: {
        addName: '商品管理新增',
        editName: '商品管理编辑',
        name_en: 'goods_detail'
    },
    listPath: 'goods_manage/goods_list'

}
//运营商管理
config.operator = {
    List: {
        name: '运营商管理',
        name_en: 'operator_list'
    },
    Detail: {
        addName: '新增运营商',
        editName: '编辑运营商',
        name_en: 'operator_detail'
    },
    listPath: 'sys_manage/operator_list'

}
config.pileRecordHistory = {
    List: {
        name: '充电日志',
        name_en: 'pile_record_history'
    }
}
// 活动管理
config.event2 = {
    List: {
        name: '活动中心',
        name_en: 'event2_list'
    },
    Detail: {
        addName: '活动新增',
        editName: '活动编辑',
        name_en: 'event2_detail'
    },
    listPath: 'server_manage/event2_list'
}
//商城
config.shopping_mall = {
    car: {
        name: '购物车',
        name_en: 'car'
    },
    goods: {
        name: '商品列表',
        name_en: 'goods'
    },
    oder_confir: {
        name: '结算',
        name_en: 'oder_confir'
    },
    pay: {
        name: '支付',
        name_en: 'pay'
    },
    payOrder: {
        name: '支付',
        name_en: 'payOrder',
    },
    we_chat: {
        name: '微信',
        name_en: 'we_chat'
    },
    we_chatOrder: {
        name: '微信',
        name_en: 'we_chatOrder'
    },
}
//经销商
config.dealer = {
    List: {
        name: '经销商',
        name_en: 'dealer_list'
    },
    Detail: {
        addName: '新建经销商',
        editName: '编辑经销商',
        name_en: 'dealer_detail'
    },
    SettlementStyle: {
        name: '结算策略',
        name_en: 'Settlement_Style',
    },
    insideDiscount: {
        name: '内部折扣',
        name_en: 'inside_Discount',
    },
    SettlementRecord: {
        name: '结算记录',
        name_en: 'Settlement_Record',
    },
    listPath: 'server_manage/dealer_list'
}
config.branch = {
    List: {
        name: '充电网点',
        name_en: 'branch_list'
    },
    Detail: {
        addName: '新建网点',
        editName: '编辑网点',
        name_en: 'branch_detail'
    },
    Pile: {
        name: '充电桩',
        name_en: 'branch_pile',
    },
    Recording: {
        name: '充电记录',
        name_en: 'branch_recording',
    },
    Strategy: {
        name: '资费策略',
        name_en: 'branch_strategy',
    },
    listPath: 'server_manage/branch_list'
}

// 路由配置
config.router = {
    login: 'login'
};

// ajax配置
config.ajax = {
    timeout: 120000,
    exportTimeout: 120000
};

// layer配置
config.layer = {
    confirm: {
        top: '150px'
    },
    msg: {
        top: '100px'
    },
    load: {
        top: '200px',
    },
    msg_timeout: 1200
};
// form表单配置
config.Form = {
    // 属性名宽度
    minLabelWidth: 130,
    midLabelWidth: 130,
    maxLabelWidth: 130
};
// list列表配置
config.list = {
    // 排序
    sortKey: 'lastModifiedWhen',
    sortValue: 'desc'
};
config.list1 = {
    // 排序
    sortKey: 'seq',
    sortValue: 'asc'
};
// 系统配置表
config.sysCfg = {
    goods: {
        goodStatus: '164',
    },
    custpushmsg: {
        msgType: '123' //消息类型
    },
    travelPlace: {
        placeStatus: '004', //景点状态
        placeType: '135', //景点类型
        placeScore: '136', //景点评分
    },
    terminal: {
        tmnlClass: '001', // 终端分类
        tmnlType: '002', // 终端类型
        tmnlStatus: '004', // 终端状态
        tmnlCfg: '005', // 终端参数
        tmnlCmd: '020', // 终端命令
    },
    event: {
        eventType: "152"
    },
    pileManage: {
        //是否享受补贴
        subsidyFlg: '055',
        //安装方式
        instType: '104',
        //运营方式
        optType: '105',
        //供电方式
        elecType: '106',
        //充电桩指令
        cmd: '115',
    },
    pileStation: {
        //充电站状态
        stationStatus: '094',
        //充电站类型
        stationType: '144',
        // 停车场类型
        portType: "143"
    },
    rcstype: {
        //是否需要授时
        needTiming: '055',
        //加密方式
        encryptionType: '096',
        //RCS与充电桩的接口类型
        interfaceChargingPole: '097',
        //RCS与充电桩的电能采集交互方式
        interopType: '098',
        //网络制式
        networkCode: '099',
    },
    autoMatain: {
        matainType: '071',
    },
    autoWarn: {
        warnType: "147",
    },
    discount: {
        useState: '149', //系统状态
    },
    tariff: {
        useState: '149', //系统状态
        chargeType: '163', //资费类型
    },
    pile: {
        currentOutType: '100', //电流类型
        chargingSpeed: '101', //充电速度类型
        interfaceType: '102', //接口类型
        useState: '149', //系统状态
        platform: '054', //运行平台
        versionSwitch: '053', //版本开关
        forcedUpdate: '055', //是否强制更新
        strategyType: '161', //结算周期
        settleType: '162', //结算方式
        useState: '149', //使用状态
        chargeType: '153',
        pileStatus: "150", //充电桩状态
        optType: '105', // 终端命令
    },
    corp: {
        corpTypeCode: '003' //公司类型
    },
    tmnlreal: {
        isOnline: '008' //设备在线状态
    },
    custInvoice: {
        invTypeCode: '080', //发票类型
        deliveryType: '082', //邮寄方式
        invStatus: '081', //票据状态
    },
    auto: {
        autoUse: '006', //车辆用途
        driveMode: '007', // 准驾级别
        autoStatus: '034', // 运营状态
        autoRentalStatusName: '075', //租赁状态
    },
    rental: {
        serMode: '012', // 服务范畴
        rtStatus: '013', // 状态
        electricFenceStatus: '071', // 电子围栏创建状态
    },
    fence: {
        fenceType: '145', // 电子围栏分类
        warnType: '146', // 警告类型
        fenceStatus: '071', // 电子围栏状态
    },
    tariffgroup: {
        groupType: '027', //资费包类型
        elecMode: '028', // 充电方式
        status: '029' // 状态
    },
    feeitem: {
        needFlag: '021', // 是否必须
        effectFlag: '022', // 生效标志
        timeLine: '023', // 时效类型
    },
    automodel: {
        autoType: '014', // 汽车类型
        autoModel: '018', // 汽车型号
        autoSpec: '015', // 汽车规格
        engineType: '016', // 动力类型
        autoLevel: '017' // 级别
    },
    autoinsurance: {
        insManfac: '032', //保险厂家
        insType: '031', //保险项目
        insStatus: '033', //保险状态
    },
    // tariff: {
    //     tariffTypeCode: '024',//资费类型
    //     unitCode: '025',//计费单位
    //     tsFlagCode: '026'//分时标志
    // },
    autocontrol: {
        cmd: '020' //指令
    },
    lvvr: {
        lvvrStatus: '035' //处理状态
    },
    app: {
        platform: '054', //运行平台
        versionSwitch: '053', //版本开关
        forcedUpdate: '055', //强制更新与否
    },
    cust: {
        creLevel: '056', //信用等级
        riskLevel: '057', //风险等级
        driveMode: '058', //准驾车型
        statusCode: '059', //客户状态
        workType: '060' //职业类型
    },
    alert: {
        alertType: '072', //通知类型
        alertMethod: '073' //通知方式
    },
    order: {
        orderStatus: '165', //订单状态
        settleStatus: '079', //支付状态
        tacCode: '132', //交通事故等级
        orderCheck: '129', //运维处理结果
        buyCarHeart: '148', //购车意向
        feedbackQuestion: '151', //反馈问题
        clearStart: '150', //清洁指数
        personStart: '149', //用户满意指数
    },
    custwalletlist: {
        transactionChannel: '050', //支付方式
        currencyType: '051', //资金类型
        operateType: '048', //操作类型
        transactionStatus: '079', //交易状态
        insManfac: '032', //公司
        appStatus: '040', // 处理状态
        informations: '110', //提示信息
        handerStatus: '111', //处理状态
    },
    coupon: {
        couponStatus: '085', //优惠券使用状态
        limitTimeType: '084' //时间限制类型
    },
    book: {
        bookStatus: '089' //预约状态
    },
    pushmessage: {
        custSex: '116', //性别
        custVerify: '117', //客户认证
        custZmxy: '118', //芝麻信用
        appType: '119', //客户端类型
        messageType: '120', //消息类型
    },
    gift: {
        giftType: '127' //礼包类型
    },
    branch: {
        yyState: "094", //网点运营状态
        carStay: "158", //是否收取停车费
        carPlace: "157", //停车场类型
        orderFrom: "154", //订单来源
    }

};
// 车辆违章管理
config.lvvr = {
    List: {
        name: '车辆违章',
        name_en: 'lvvr_list'
    },
    BigImg: {
        name: '查看图片',
        name_en: 'cust_bigImg'
    },
};
// 车辆违章管理
config.feedback = {
    List: {
        name: '客户反馈',
        name_en: 'feedback_list'
    },
    BigImg: {
        name: '查看图片',
        name_en: 'cust_bigImg'
    },
};
// 设备信息履历
config.tmnlinfo = {
    List: {
        name: '设备履历',
        name_en: 'tmnlinfo_list'
    },
};
// 实时电池信息
config.tmnlbatteryinfo = {
    List: {
        name: '电池履历',
        name_en: 'tmnlbatteryinfo_list'
    },
};
// 车辆监控
config.autocontrol = {
    Main: {
        name: '车辆监控',
        name_en: 'auto_control_main'
    }
};
// 仪表盘
config.dashboard = {
    TmnlKpi: {
        name: '设备KPI',
        name_en: 'tmnl_kpi',
    },
    ShareKpi: {
        name: '运营KPI',
        name_en: 'share_kpi',
    },
};


// 系统配置
config.sysconfig = {
    List: {
        name: '系统配置',
        name_en: 'sys_config'
    },
    Detail: {
        editName: '配置编辑',
        addName: '配置新增',
        name_en: 'sys_config_detail'
    },
    listPath: 'sys_manage/sys_config'
};

// 车桩一体
config.autorental = {
    Main: {
        name: '车桩一体',
        name_en: 'auto_rental'
    },
};
// 公共充电桩
config.chargingpile = {
    List: {
        name: '公共充电桩',
        name_en: 'public_pile_list'
    },
    Detail: {
        editName: '编辑充电桩',
        addName: '配置新增',
        name_en: 'pubpile_detail'
    },
    record: {
        name: '充电记录',
        name_en: 'pile_record'
    },

    errorrecord: {
        name: '故障记录',
        name_en: 'pile_error_detail'
    },
    listPath: 'sys_manage/sys_config'
};
// 私人充电桩管理
config.privatePile = {
    List: {
        name: '私人充电桩管理',
        name_en: 'private_pile_list'
    },
    record: {
        name: '充电记录',
        name_en: 'pile_record'
    },

    errorrecord: {
        name: '故障记录',
        name_en: 'pile_error_detail'
    },
    listPath: 'sys_manage/sys_config'
};
// 充电桩
config.allpile = {
    List: {
        name: '私人充电桩',
        name_en: 'pile_list'
    },
    Detail: {
        editName: '编辑充电桩',
        addName: '配置新增',
        name_en: 'pile_detail'
    },
    record: {
        name: '充电记录',
        name_en: 'pile_record'
    },
    findPileCode:{
        name:'充电桩信息查询',
        name_en: 'find_pile'
    },
    listPath: 'sys_manage/sys_config'
};
// 结算策略
config.settle = {
    List: {
        name: '结算策略',
        name_en: 'settle_list'
    },
    Detail: {
        editName: '编辑结算策略',
        addName: '新建结算策略',
        name_en: 'settle_detail'
    },
    listPath: 'server_manage/settle_list'
};
// 充电用户
config.charginguser = {
    List: {
        name: '充电用户',
        name_en: 'cust_list'
    },
    Detail: {
        editName: '编辑充电用户',
        addName: '新增充电用户',
        name_en: 'cust_detail'
    },
    record: {
        name: '公共充电记录',
        name_en: 'user_record'
    },
    personRecord: {
        name: '个人充电记录',
        name_en: 'user_personRecord'
    },
    account: {
        name: '账户记录',
        name_en: 'account_detail'
    },
    modify_money: {
        name: '修改账户余额',
        name_en: 'modify_money',
    },
    change_money: {
        name: '余额修改',
        name_en: 'change_money'
    },
    listPath: 'server_manage/cust_list'
};

// 充电桩型号管理
config.piletype = {
    Main: {
        name: '充电桩型号列表',
        name_en: 'piletype_list'
    },
    Detail: {
        editName: '充电桩型号编辑',
        addName: '充电桩型号新增',
        name_en: 'pileType_detail'
    },
    listPath: 'pile_manage/piletype_list'
};

//批量桩控制
config.mulpile_control = {
    List: {
        name: '批量桩控制',
        name_en: 'mulpile_control'
    },
    listPath: 'pile_manage/mulpile_control'
};

// 充电桩升级
config.upgrade = {
    List: {
        name: '充电桩升级任务管理',
        name_en: 'upgrade_list'
    },
    Detail: {
        name: '查看充电桩编号',
        name_en: 'upgrade_detail'
    },
    Create: {
        name: '创建任务',
        name_en: 'upgrade_create'
    },
    listPath: 'pile_manage/upgrade_list'
};

// 订单管理
config.order_manage = {
    order_all: {
        name: '全部充电订单',
        name_en: 'order_all_list'
    },
    order_abnormal: {
        name: '异常充电订单',
        name_en: 'order_abnormal_list'
    },
    order_history: {
        name: '历史报文',
        name_en: 'order_history_list'
    },
    order_exports: {
        name: '充电订单导出',
        name_en: 'order_export'
    }
}


// 礼包管理
config.gift = {
    List: {
        name: '礼包管理',
        name_en: 'gift_list'
    },
    Detail: {
        editName: '礼包编辑',
        addName: '礼包新增',
        name_en: 'gift_detail'
    },
    Allot: {
        name: '礼包分配优惠券',
        name_en: 'gift_allot'
    },
    Show: {
        name: '礼包优惠券详情',
        name_en: 'gift_show'
    },
    listPath: 'server_manage/gift_list'
}
// 路径配置
// let menuName = Cookies.get('menuName');
let menuName = '';
config.listPath = {
    main: {
        name: '首页',
        name_en: menuName
    },
    dash_board: '仪表盘',
    cust_manage: '客户管理',
    sys_manage: '系统管理',
    report_manage: '报表管理',
    charging_facilities: '充电设施',
    terminal_manage: '设备管理',
    car_manage: '车辆管理',
    tariff_manage: '资费管理',
    rental_manage: '网点管理',
    log_manage: '日志管理',
    server_manage: '运营管理',
    operation_manage: '运维管理',
    pile_manage: '充电设施',
    order_manage: '订单管理',
    finance_manage: '财务管理',
    custFinance_list: '财务处理',
    fenceAlert_list: '报警信息',
    dealer_manage: '运营管理',
    goods_manage: '商品服务管理',
    branch_list: {
        title: '充电网点',
        name: 'branch_list'
    },
    branch_pile: {
        title: '充电桩',
        name: 'branch_pile'
    },
    branch_recording: {
        title: '充电记录',
        name: 'branch_recording'
    },
    branch_strategy: {
        title: '资费策略',
        name: 'branch_strategy'
    },
    dealer_list: {
        title: '经销商',
        name: 'dealer_list'
    },
    user_list: {
        title: '用户管理',
        name: 'user_list'
    },
    fenceAlert_list: {
        title: '报警信息',
        name: 'fenceAlert_list'
    },
    rental_statistics: {
        title: '网点营业统计',
        name: 'rental_statistics'
    },
    orderTimeInterval_list: {
        title: '客户下单时段报表',
        name: 'orderTimeInterval_list'
    },
    event_list: {
        title: "二维码管理",
        name: "event_list"
    },
    pilestation_list: {
        title: "充电站管理",
        name: 'pilestation_list'
    },
    autoteam_list: {
        title: "车队管理",
        name: "autoteam_list"
    },
    autoMatain_list: {
        title: "车辆运维",
        name: "autoMatain_list"
    },
    autoWarn_list: {
        title: '车辆报警',
        name: 'autoWarn_list'
    },
    userRegister_list: {
        title: '用户注册统计表',
        name: 'userRegister_list'
    },
    charge_list: {
        title: '充电桩管理',
        name: 'charge_list'
    },
    charge_detail: {
        title: '充电桩编辑',
        name: 'charge_detail'
    },
    rcstype_list: {
        title: 'RCS型号管理',
        name: 'rcstype_list'
    },
    rcs_list: {
        title: "RCS设备管理",
        name: "rcs_list"
    },
    pileotarecord_list: {
        title: "OTA通讯记录",
        name: "pileotarecord_list"
    },
    pilehistory_list: {
        title: "OTA通讯协议解析",
        name: "ilehistory_list"
    },
    custsms_list: {
        title: "客户短信查询",
        name: "custsms_list"
    },
    rpt_list: {
        title: "用户来源报表",
        name: "rpt_list"
    },
    optorderReportForm_list: {
        title: "运维报表",
        name: "optorderReportForm_list"
    },
    orderTrend_list: {
        title: "订单趋势分析报表",
        name: "orderTrend_list"
    },
    pile_list: {
        title: '桩列表',
        name: 'pile_list'
    },
    pileType_list: {
        title: '充电桩型号管理',
        name: 'piletype_list'
    },
    role_list: {
        title: '角色管理',
        name: 'role_list'
    },
    corp_list: {
        title: '公司管理',
        name: 'corp_list'
    },
    org_list: {
        title: '组织机构',
        name: 'org_list'
    },
    cust_list: {
        title: '客户列表',
        name: 'cust_list'
    },
    custFinance_list: {
        title: '财务处理',
        name: 'custFinance_list'
    },
    order_list: {
        title: '订单列表',
        name: 'order_list'
    },
    coupon_list: {
        title: '优惠券管理',
        name: 'coupon_list'
    },
    discount_list: {
        title: '折扣管理',
        name: 'discount_list'
    },
    cashcard_list: {
        title: '兑换卡管理',
        name: 'cashcard_list'
    },
    advert_list: {
        title: '广告页面',
        name: 'advert_list'
    },
    advert_delivery_list: {
        title: '广告投放',
        name: 'advert_delivery_list'
    },
    operator_list: {
        title: '运营商管理',
        name: 'operator_list',
    },
    ledger_list: {
        title: '运营台账',
        name: 'ledger_list',
    },
    goods_list: {
        title: '商品管理',
        name: 'goods_list'
    },
    settle_list: {
        title: '结算策略',
        name: 'settle_list'
    },
    event2_list: {
        title: '活动管理',
        name: 'event2_list'
    },
    custwalletlist_list: {
        title: '客户资金',
        name: 'custwalletlist_list'
    },
    walletlist_list: {
        title: '资金列表',
        name: 'walletlist_list'
    },
    custInvoice_list: {
        title: '发票管理',
        name: 'custInvoice_list'
    },
    tariffgroup_list: {
        title: '资费包管理',
        name: 'tariffgroup_list'
    },
    feeitem_list: {
        title: '费用管理',
        name: 'feeitem_list'
    },
    tariff_list: {
        title: '资费管理',
        name: 'tariff_list'
    },
    custWalletEarnestWithDraw_list: {
        title: '退费管理',
        name: 'custWalletEarnestWithDraw_list'
    },
    rental_list: {
        title: '网点列表',
        name: 'rental_list'
    },
    fence_list: {
        title: '围栏列表',
        name: 'fence_list'
    },
    sdbs_bus: {
        title: '新能源大巴数据展示',
        name: 'sdbs_bus'
    },
    travelPlace_list: {
        title: '景点列表',
        name: 'travelPlace_list'
    },
    terminal_list: {
        title: '设备列表',
        name: 'terminal_list'
    },
    tmnlreal_list: {
        title: '设备状态',
        name: 'tmnlreal_list'
    },
    lvvr_list: {
        title: '车辆违章',
        name: 'lvvr_list'
    },
    feedback_list: {
        title: '客户反馈',
        name: 'feedback_list'
    },
    tmnlinfo_list: {
        title: '设备履历',
        name: 'tmnlinfo_list'
    },
    tmnlbatteryinfo_list: {
        title: '电池信息履历',
        name: 'tmnlbatteryinfo_list'
    },
    tmnltest_tmnltest: {
        title: '设备测试',
        name: 'tmnltest_tmnltest'
    },
    automodel_list: {
        title: '车型管理',
        name: 'automodel_list'
    },
    auto_list: {
        title: '车辆列表',
        name: 'auto_list'
    },
    autoinsurance_list: {
        title: '车辆保险',
        name: 'autoinsurance_list'
    },
    autobattery_list: {
        title: '车辆电池',
        name: 'autobattery_list'
    },
    autostopsummary_list: {
        title: '车辆停留汇总',
        name: 'autostopsummary_list'
    },
    autostoprecord_list: {
        title: '车辆停留记录',
        name: "autostoprecord_list"
    },
    otacommand_list: {
        title: '命令日志',
        name: 'otacommand_list'
    },
    otarecord_list: {
        title: 'OTA实时信息日志',
        name: 'otarecord_list'
    },
    loginlog_list: {
        title: '登录日志',
        name: 'loginlog_list'
    },
    auto_control_main: {
        title: '车辆监控',
        name: 'auto_control_main'
    },
    app_list: {
        title: '版本管理',
        name: 'app_list'
    },
    alert_list: {
        title: '系统通知',
        name: 'alert_list'
    },
    operation_list: {
        title: '运维人员',
        name: 'operation_list'
    },
    optorder_list: {
        title: '运维订单',
        name: 'optorder_list'
    },
    book_list: {
        title: '预约订单',
        name: 'book_list'
    },
    actionlog_list: {
        title: '操作日志',
        name: 'actionlog_list'
    },
    pushmessage_list: {
        title: '消息群推',
        name: 'pushmessage_list'
    },
    gift_list: {
        title: '礼包管理',
        name: 'gift_list'
    },
    order_orderlvar: {
        title: '事故登记',
        name: 'order_orderlvar'
    },
    orderfeedback_list: {
        title: '订单反馈',
        name: 'orderfeedback_list'
    },
    pile_control: {
        title: '桩控制',
        name: 'pilecontrol'
    },
    pile_set: {
        title: '桩控制',
        name: 'pile_set'
    },
    mulpile_control: {
        title: '批量桩控制',
        name: 'mulpile_control'
    },
    order_all: {
        title: '全部充电订单',
        name: 'order_all_list'
    },
    order_abnormal: {
        title: '异常充电订单',
        name: 'order_abnormal_list'
    },
    order_history: {
        title: '历史报文',
        name: 'order_history_list'
    }
};

// 文本域配置
config.textarea = {
    minRows: 3,
    maxRows: 8
};

//正则配置
config.Reg = {
    //正则表达式匹配网址
    url: /^(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?$/,
    //只能输入大小写字母和数字的组合
    alphabet: /^[0-9a-zA-Z]{1,32}$/,
    intVal: /^[0-9]+$/,
    //0-1之间
    oneToZero: /^(0(\.\d{0,2})?|1)$/,
    //最多保留两位数字
    numberDecimal: /^(([1-9]\d*|0)(|\.\d{1,3}))$/,
    //正整数和正小数，且不为0
    numberDecimalN: /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{2}$)/,
    number: /^([1-9]\d*|0)(\.\d{1,10})?$/,
    //小数点前限制8位，小数点后保留两位
    numberDec: /^\d{1,8}(\.\d{1,2})?$/,
    //小数点前限制8位，小数点后保留两位,正负数皆可
    numberPnm: /(^([-]?)[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^([-]?)(0){1}$)|(^([-]?)[0-9]\.[0-9]([0-9])?$)/,
    decimal: /^(((\d|[1-9]\d)(\.\d{1,2})?)|100|100.0|100.00)$/, //0-100保留两位有效数字
    intHundred: /^(([1-9]\d?))$/,
    mobile: /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(16[6])|(17[0,1,3,5-8])|(18[0-9])|(19[8,9]))\d{8}$/,
    fixedtelephone: /(^(0\d{2,3}-\d{7,8})(-\d{1,4})?$)|(^[1][3,4,5,7,8][0-9]{9}$)/,
    assetNo: /^\d{0,5}$/,
    age: /^(1[89]|[2-8]\d|90)$/,
    idCard: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
    driveNo: /^(^\d{12})$/,
    inExpAmount: /^(0|[1-9]\d{0,17})(\.\d{0,2})?$/,
    inExpAmountNotZero: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,9}|0)(?:\.\d{1,2})?$/,
    licenseNo: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$/,
    numAndWord: /^[a-zA-Z\d]{17}$/, //英文+数字/^([0-9A-Z]){17}$/
    wordAndNum: /^[a-zA-Z\d]+$/,
    email: /^[a-zA-Z0-9_-]+@[A-Za-z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
    password: /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,16}$/, //与app端同步的客户密码正则
    LonLatReg: /^[\-\+]?(0?\d{1,2}\.\d{1,6}|1[0-7]?\d{1}\.\d{1,6}|180\.0{1,6})\,[\-\+]?([0-8]?\d{1}\.\d{1,6}|90\.0{1,6})$/,
    LonLatsReg: /^([\-\+]?(0?\d{1,2}\.\d{1,6}|1[0-7]?\d{1}\.\d{1,6}|180\.0{1,6})\,[\-\+]?([0-8]?\d{1}\.\d{1,6}|90\.0{1,6})\;?)*$/
};

// 加载的时间配置
config.load = {
    quick_time: 500,
    fast_time: 1000,
    mid_time: 1500
};
config.sysId = 'A009';

config.intervalTime = 60000; //定时函数60s一刷新

//地图配置
// config.map = {
//     markerClustererStyle: [{
//         url: "http://a.amap.com/jsapi_demos/static/images/blue.png",
//         size: new AMap.Size(32, 32),
//         offset: new AMap.Pixel(-16, -16)
//     }, {
//         url: "http://a.amap.com/jsapi_demos/static/images/green.png",
//         size: new AMap.Size(32, 32),
//         offset: new AMap.Pixel(-16, -16)
//     }, {
//         url: "http://a.amap.com/jsapi_demos/static/images/orange.png",
//         size: new AMap.Size(36, 36),
//         offset: new AMap.Pixel(-18, -18)
//     }, {
//         url: "http://a.amap.com/jsapi_demos/static/images/red.png",
//         size: new AMap.Size(48, 48),
//         offset: new AMap.Pixel(-24, -24)
//     }, {
//         url: "http://a.amap.com/jsapi_demos/static/images/darkRed.png",
//         size: new AMap.Size(48, 48),
//         offset: new AMap.Pixel(-24, -24)
//     }],
// };
// 项目名称
config.vue = {
    projectName: '桩到家3.0',
    projectShortName: 'ZD',
};

//车贴url
config.qrCodeSrc = 'http://www.evjack.com?t=1&y=';

//appDevice
config.appDevice = '01';
config.sysId = '987B58DB5742F01310F368B783852642';

// 主题颜色配置
config.main_theme_color = ['#1AB394', '#17afb1', '#e4982a', '#f0f0f0'];

// 八闽操作手册
config.bmUserGuideUrl = "http://djjk.evjack.com:7777/static/user-guide.pdf";
config.evjackUserGuideUrl = "http://djjk.evjack.com:8888/static/user-guide.pdf";

export default config;
